/* eslint-disable no-magic-numbers */
// 广告结果页
import React, { useCallback, useState, useEffect, useRef } from 'react'
import styles from './ios-skin.module.scss'
import classNames from 'classnames'
import { Button, Swiper, InfiniteScroll } from 'antd-mobile'
import { isIOS } from '@bihu/common-js'
import indexApi from '@/apis'
import { SwiperRef } from 'antd-mobile/es/components/swiper'
import JointLoginPopup from '@/components/joint-login-popup/joint-login-popup'
interface Props {
  productName?: '', // 产品名字
  applyStatus?: number, // hold单状态
  revisit?: any, // 二次回访结果页
  onChange: () => void, // 改变事件
}

const IosSkin: React.FC<Props> = props => {
  const { productName, onChange, applyStatus, revisit } = props
  const [banners, setBanners] = useState<any>([])
  // 获取产品列表
  useEffect(() => {
    if (productName) {
      return
    }
    async function homeProductList() {
      const res:any = await indexApi.topRecommend()
      const tempBanners = res.map((item:any) => {
        item.lendingRateString = Math.round(Math.random() * 6 + 88)
        return item
      })
      setBanners([...tempBanners])
    }
    homeProductList()
  }, [])

  const [hotProductList, setHotProductList] = useState<any>([])
  // 获取产品列表
  useEffect(() => {
    if (productName) {
      return
    }
    async function homeProductList() {
      const res:any = await indexApi.homeProductList({ appH5: 2 })
      let tempProductList = [...res.hotRecommends, ...res.jumboLoanRecommends, ...res.microfinanceRecommends]
      setHotProductList(tempProductList)
    }
    homeProductList()
  }, [])

  // 贷超页产品列表（进件成功展示 contact 图时使用）
  const [recommendList, setRecommendList] = useState<any[]>([])
  const [pageNum, setPageNum] = useState<number>(1)
  const [hasMore, setHasMore] = useState<boolean>(false)
  const [loadMoreShow, setLoadMoreShow] = useState<boolean>(false)

  useEffect(() => {
    if (!productName) {
      return
    }
    fetchRecommendList()
  }, [pageNum, productName])

  const fetchRecommendList = () => {
    setLoadMoreShow(false)
    indexApi.getProductList({
      pageNum
    }).then(res => {
      // 多重判断是否还有更多数据
      const pageSize = res.pageSize || 15 // 默认每页15条
      const hasMoreData = res.rowList.length > 0
        && (res.totalPage ? pageNum < res.totalPage : true)
        && (res.totalRecord ? recommendList.length + res.rowList.length < res.totalRecord : true)
        && res.rowList.length >= pageSize

      if (res.rowList.length === 0) {
        setHasMore(false)
        return
      }

      setRecommendList(prev => {
        if (pageNum === 1) {
          return res.rowList
        }
        return [...prev, ...res.rowList]
      })

      setHasMore(hasMoreData)
    })
      .finally(() => {
        setLoadMoreShow(true)
      })
  }

  const loadMore = async() => {
    if (loadMoreShow && hasMore) {
      setPageNum(prev => prev + 1)
    }
  }

  // 点击产品
  const applyProduct = async(item:any, entranceType:number) => {
    let res:any = await indexApi.applyFor({
      productId: item.id,
      entranceType,
      appH5: 2
    })
    // if (res.unionLoginFlag === 1) {
    //   const params = {
    //     productId: item.id,
    //     productName: item.productName,
    //     productLogo: item.productLogo,
    //     h5Protocols: res.h5Protocols,
    //     loansLimitMax: item.loansLimitMax,
    //     entranceType,
    //     appH5: 2
    //   }
    //   // 打开产品联登授权弹窗
    //   JointLoginModalRef.current?.init(params)
    //   return
    // }
    window.location.href = res.thirdpartyTargetUrl
  }

  const formSwiper = useRef<SwiperRef>(null)
  const [currentSwiperIndex, setCurrentSwiperIndex] = useState(0)
  const [exposureProductIds, setExposureProductIds] = useState<any>([])

  const onChangeSwiper = (index:number) => {
    setCurrentSwiperIndex(index)
    // 判断是否已经曝光过
    const isExposure = exposureProductIds.find((item:any) => item === banners[index].id)
    if (isExposure) {
      return
    }
    exposureProductIds.push(banners[index].id)
    setExposureProductIds([...exposureProductIds])
    // 上报产品曝光
    indexApi.reportProductExposure({
      productId: banners[index].id,
      entranceType: 4,
      appH5: 2
    })
  }

  // 千位分隔符
  const numFormat = (num:number) => {
    if (!num) {
      return
    }
    let res = num.toString().replace(/\d+/, n => { // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => {
        return `${$1},`
      })
    })
    return res
  }

  const JointLoginModalRef: any = useRef()

  const swiperItems = banners.map((swiperItem:any, swiperIndex:any) => (
    <Swiper.Item key={swiperIndex}>
      <div className={styles.swiperBoxItem} onClick={() => applyProduct(swiperItem, 4)}>
        <div className={styles.swiperItemProduction}>
          <img className={styles.swiperItemProductionLogo} src={swiperItem.productLogo} alt="productLogo" />
          <div className={styles.swiperItemProductionName}>{swiperItem.productName}</div>
          <div className={styles.swiperItemProductionLine}></div>
          <div className={styles.swiperItemProductionTips}>因您资质良好，为您推荐</div>
        </div>
        <div className={styles.swiperItemText1}>最高可借(元)</div>
        <div className={styles.swiperItemText2}>{numFormat(swiperItem.loansLimitMax)}</div>
        <div className={styles.LoanBox}>
          <img className={styles.LoanBoxBg} src={require('@imgs/ios-skin/LoanBox.png')} alt="LoanBox" />
          <span className={styles.LoanBoxText}>今日放款率{swiperItem.lendingRateString}%</span>
        </div>
        <Button block className={styles.btn} shape="rounded" color="primary">
          我要申请
        </Button>
      </div>
    </Swiper.Item>
  ))

  return (
    <div className={styles.iosSkin}>
      { productName ? <>
        <div className={styles.contactBg}>
          <img className={styles.contact} src={require('@imgs/ios-skin/contact.png')} alt="success" />
          <div className={styles.contactMask}></div>
        </div>
        {/* 为您推荐更多产品（贷超页数据） */}
        <div className={styles.recommendBox}>
          <div className={styles.recommendTitle}>
            <img className={styles.recommendTitleLine} src={require('@imgs/ios-skin/title-line-left.png')} alt="title-line-left" />
            <span className={styles.recommendTitleText}>为您推荐更多产品</span>
            <img className={styles.recommendTitleLine} src={require('@imgs/ios-skin/title-line-right.png')} alt="title-line-right" />
          </div>
          <div className={styles.recommendListBox}>
            {
              recommendList.map((item:any, index:number) => (
                <div key={index} className={styles.recommendItem}>
                  <div className={styles.recommendItemTop}>
                    <img className={styles.recommendItemLogo} src={item.productLogo} alt="productLogo" />
                    <div className={styles.recommendItemName}>{item.externalName}</div>
                    <div className={styles.recommendLabelBox}>
                      {item.labels && item.labels.length > 0
                        && item.labels.map((label: string, labelIndex: number) => (
                          <div key={labelIndex} className={classNames(styles.recommendLabel, labelIndex === 0 ? '' : styles.recommendLabelTwo)}>{label}</div>
                        ))
                      }
                    </div>
                  </div>
                  <div className={styles.recommendItemMain}>
                    <div>
                      <div className={styles.recommendPrice}>{numFormat(item.loansLimitMax)}</div>
                      <div className={styles.recommendMainText}>额度高达(元)</div>
                    </div>
                    <div>
                      <div className={styles.recommendInterest}>{item.annualInterestRate ? `${item.annualInterestRate}%` : `${parseFloat((item.monthlyInterestRate * 12).toFixed(2))}%`}</div>
                      <div className={styles.recommendMainText}>年利率(单利)低至</div>
                    </div>
                    <div className={styles.recommendApplyBtn} onClick={() => applyProduct(item, 6)}>立即申请</div>
                  </div>
                </div>
              ))
            }
          </div>
          <InfiniteScroll
            loadMore={loadMore}
            hasMore={hasMore}
            threshold={250}
            style={!hasMore ? { display: 'none' } : {}}
          >
          </InfiniteScroll>
        </div>
      </> : <>
        {
          (isIOS || revisit) && <div className={styles.downloadBar} onClick={onChange}>
            <div className={styles.downloadAppLeft}>
              <img className={styles.downloadBarLogo} src={require('@imgs/yuanxin-logo-2.png')} alt="logo" />
              <span>查看更多产品</span>
            </div>
            <div className={styles.downloadBtn}>下载APP</div>
          </div>
        }
        <div className={styles.main}>
          <div className={styles.logoBox}>
            <img className={styles.logo} src={require('@imgs/weifutong-logo.png')} alt="logo" />
            <div className={styles.logoBoxRight}>
              {/* {
                localStorage.getItem('hostName') === '卫付通' ? <>
                  <img className={styles.logoText} src={require('@imgs/youqianlai-text.png')} alt="youqianlai-text" />
                </> : <>
                  <img className={styles.youqianLogoText} src={require('@imgs/youqian-text.png')} alt="youqian-text" />
                </>
              } */}
              <img className={styles.logoText2} src={require('@imgs/register/new-theme/logo-subtitle.png')} alt="正规品牌 真实可信" />
            </div>
          </div>
          {
            productName && <div className={styles.applyResultBox}>
              <img className={styles.applyResultBoxIcon} src={require('@imgs/ios-skin/success.png')} alt="success" />
              {
                applyStatus === 8 ? <>
                  <div className={styles.applyResultBoxRight}>
                    <div className={styles.applyResultBoxText1}>恭喜, <span className={styles.applyPrductionName}>{productName}</span>匹配成功！</div>
                    <div className={styles.applyResultBoxText2}>审核人员将在<span className={styles.highlight}>工作时间来电</span>完成审核</div>
                  </div>
                </> : <>
                  <div className={styles.applyResultBoxRight}>
                    <div className={styles.applyResultBoxText1}>恭喜, <span className={styles.applyPrductionName}>{productName}</span>申请成功！</div>
                    <div className={styles.applyResultBoxText2}>请留意审核人员来电，完成信息审核</div>
                  </div>
                </>
              }
            </div>
          }
          <div className={styles.containers}>
            {
              !productName && <div className={styles.noApplyResultBox}>
                <img className={styles.noApplyResultBoxIcon} src={require('@imgs/ios-skin/success-2.png')} alt="success-2" />
                <span className={styles.noApplyResultBoxText}>预审通过</span>
              </div>
            }
            <div className={styles.swiperBox}>
              <Swiper
                ref={formSwiper}
                indicator={() => null}
                loop
                autoplay
                autoplayInterval={4000}
                defaultIndex={currentSwiperIndex}
                onIndexChange={onChangeSwiper}
              >
                {swiperItems}
              </Swiper>
            </div>
            <div className={styles.indicatorBox}>
              {
                banners.map((swiperItem:any, swiperIndex:any) => (
                  <div key={swiperIndex} className={classNames(styles.indicatorBoxItem, swiperIndex === currentSwiperIndex ? styles.active : '')}></div>
                ))
              }
            </div>
            <div className={styles.productBox}>
              <div className={styles.title}>为您推荐-待申请</div>
              <div className={styles.productListBox}>
                {
                  hotProductList.map((item:any, index: number) => {
                    return <div key={index} className={classNames(styles.card, 'productCard')} onClick={() => applyProduct(item, 6)}>
                      <div className={styles.left}>
                        <div className={styles.productLimit}>￥{ numFormat(item.loansLimitMax) }</div>
                        <div className={styles.productCompanyBox}>
                          <img className={styles.productCompanyIcon} src={item.productLogo} alt="productLogo" />
                          <span className={styles.productCompanyName}>额度由{item.productName}提供</span>
                        </div>
                      </div>
                      <div className={classNames(styles.apply)}>立即申请</div>
                    </div>
                  })
                }
              </div>
            </div>
          </div>
          <div className={styles.footerBox}>
            <div className={styles.titleBox}>
              <img className={styles.titleLine} src={require('@imgs/ios-skin/title-line-left.png')} alt="title-line-left" />
              <div className={styles.titleText}>正规产品 安全信赖</div>
              <img className={styles.titleLine} src={require('@imgs/ios-skin/title-line-right.png')} alt="title-line-left" />
            </div>
            <div className={styles.sortBox}>
              <div className={styles.sortBoxItem}>
                <img className={styles.sortBoxImg} src={require('@imgs/ios-skin/sort-1.png')} alt="img" />
                <div className={styles.sortBoxItemText}>选择推荐产品</div>
              </div>
              <img className={styles.sortBoxArrow} src={require('@imgs/ios-skin/sort-arrow.png')} alt="img" />
              <div className={styles.sortBoxItem}>
                <img className={styles.sortBoxImg} src={require('@imgs/ios-skin/sort-2.png')} alt="img" />
                <div className={styles.sortBoxItemText}>匹配机构</div>
              </div>
              <img className={styles.sortBoxArrow} src={require('@imgs/ios-skin/sort-arrow.png')} alt="img" />
              <div className={styles.sortBoxItem}>
                <img className={styles.sortBoxImg} src={require('@imgs/ios-skin/sort-3.png')} alt="img" />
                <div className={styles.sortBoxItemText}>提现放款</div>
              </div>
            </div>
          </div>
          <div className={styles.footerText}>
            郑重声明:平台只提供贷款咨询和推荐服务，放款由机构进行，所有贷款申请在未成功贷款前绝不收取任何费用，为了保证您的资全安全，请不要相信任何要求您支付费用的信息、邮件电话等不实信息贷款额度，利率，放款时间以实际南批结果为准。
          </div>
        </div>

        <JointLoginPopup ref={JointLoginModalRef}></JointLoginPopup>
      </>}
    </div>
  )
}

export default IosSkin
